import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { IconSeekers } from 'ui-seeker/core'

export default function TourTriggerButton({ onClick }) {
    const { t } = useTranslation('common')
    return <button
        onClick={onClick}
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            height: '30px',
            marginLeft: '8px',
            padding: '0 10px',
            fontSize: '11px',
            fontWeight: 600,
            color: '#2474b2',
            background: '#EBF5FF',
            border: '1px solid #C6DEFF',
            borderRadius: '20px',
            cursor: 'pointer',
            transition: 'all 0.15s ease',
            whiteSpace: 'nowrap',
            fontFamily: 'inherit',
            letterSpacing: '0.2px',
        }}
        onMouseEnter={e => {
            e.currentTarget.style.background = '#D6EAFF'
            e.currentTarget.style.borderColor = '#2474b2'
        }}
        onMouseLeave={e => {
            e.currentTarget.style.background = '#EBF5FF'
            e.currentTarget.style.borderColor = '#C6DEFF'
        }}
    >
        <IconSeekers icon="route" iconType="fontAwesome" iconWeight="fal" style={{ fontSize: '11px' }} />
        {t('misc.virtualTour')}
    </button>
}
